<div class="col-lg-12">
    <div id="top-text-title">
        Our Company
    </div>
    <div id="text-content">
        "Smart Century Technologies" is a digital transformation consultancy, hardware and software end-to-end development company.<br><br>
        We provide custom software enterprise development, full-cycle Engineering of Microcomputers, IoT, Smart Connectivity Solutions and IT outsourcing services.<br>
        Our team has an innovative problem-solving skills, in-depth expertise and enthusiasm toward work make us a strong partner in the field of hardware and software development.<br><br>
        The company headquarter is located in Stara Zagora, Bulgaria.
    </div>
</div>